import { useEffect } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import {
  OthersService,
  PromotionParticulars,
  ServiceHistory,
} from "./components";

import { useServices } from "@hooks/HRM/employee/useServices";

export interface ServicesPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
}

function Services({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  isProfileDisabled,
}: ServicesPropsType) {
  const {
    servicesInfo,

    changeOtherServicesInfo,
    changePromotionParticularsInfo,
    changeServicesHistoryInfo,

    removeOtherServicesInfo,
    removePromotionParticularsInfo,
    removeServicesHistoryInfo,

    getServicesRequestOngoing,

    updateServiceHistoryRequestOngoing,
    updateServiceHistorySuccess,
    updateServiceHistoryFailed,

    updatePromotionParticularRequestOngoing,
    updatePromotionParticularSuccess,
    updatePromotionParticularFailed,

    updateOtherServiceRequestOngoing,
    updateOtherServiceSuccess,
    updateOtherServiceFailed,

    deleteServicesHistoryRequestOngoing,
    deleteServicesHistorySuccess,
    deleteServicesHistoryFailed,

    deletePromotionParticularRequestOngoing,
    deletePromotionParticularSuccess,
    deletePromotionParticularFailed,

    deleteOtherServiceRequestOngoing,
    deleteOtherServiceSuccess,
    deleteOtherServiceFailed,
  } = useServices(id);

  const { serviceHistories, promotionParticulars, otherServices } =
    servicesInfo || {};

  useEffect(() => {
    setIsSuccessModalOpen(
      updateServiceHistorySuccess ||
        updatePromotionParticularSuccess ||
        updateOtherServiceSuccess ||
        deleteServicesHistorySuccess ||
        deletePromotionParticularSuccess ||
        deleteOtherServiceSuccess,
    );
    setIsErrorModalOpen(
      updateServiceHistoryFailed ||
        updatePromotionParticularFailed ||
        updateOtherServiceFailed ||
        deleteServicesHistoryFailed ||
        deletePromotionParticularFailed ||
        deleteOtherServiceFailed,
    );
  }, [
    updateServiceHistorySuccess,
    updatePromotionParticularSuccess,
    updateOtherServiceSuccess,
    deleteServicesHistorySuccess,
    deletePromotionParticularSuccess,
    deleteOtherServiceSuccess,
    updateServiceHistoryFailed,
    updatePromotionParticularFailed,
    updateOtherServiceFailed,
    deleteServicesHistoryFailed,
    deletePromotionParticularFailed,
    deleteOtherServiceFailed,
    ,
  ]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.SERVICES_INFO.HEADING"
      subtitle="EMPLOYEE.SERVICES_INFO.DESCRIPTION"
      action={() => changeActiveTab(5)}
    >
      <div className="d-flex flex-column gap-10">
        <ServiceHistory
          servicesHistoryInfo={serviceHistories}
          changeServiceHistoryInfo={changeServicesHistoryInfo}
          removeServiceHistoryInfo={removeServicesHistoryInfo}
          getServicesRequestOngoing={getServicesRequestOngoing}
          updateServicesHistoryRequestOngoing={
            updateServiceHistoryRequestOngoing
          }
          deleteServicesHistoryRequestOngoing={
            deleteServicesHistoryRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <PromotionParticulars
          promotionParticularsInfo={promotionParticulars}
          changePromotionParticularsInfo={changePromotionParticularsInfo}
          removePromotionParticularsInfo={removePromotionParticularsInfo}
          getServicesRequestOngoing={getServicesRequestOngoing}
          updatePromotionParticularRequestOngoing={
            updatePromotionParticularRequestOngoing
          }
          deletePromotionParticularRequestOngoing={
            deletePromotionParticularRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <OthersService
          otherServicesInfo={otherServices}
          changeOtherServicesInfo={changeOtherServicesInfo}
          removeOtherServicesInfo={removeOtherServicesInfo}
          getServicesRequestOngoing={getServicesRequestOngoing}
          updateOtherServiceRequestOngoing={updateOtherServiceRequestOngoing}
          deleteOtherServiceRequestOngoing={deleteOtherServiceRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
      </div>
    </HeaderWithNextButtonLayout>
  );
}

export default Services;
